import * as values from './values.js';
import getById from '../../getById';

export default getById(values);
